import type { Lesson } from "@otto/lehrgang";
import { StageDots } from "./StageDots.js";
import own from "./TrainerHeader.module.css";

export function TrainerHeader({
  lesson,
  title,
  doneCount,
  currentIndex,
  allDone,
  onBack,
}: {
  lesson: Lesson;
  /** Stage title while practising, lesson subtitle otherwise. */
  title: string;
  doneCount: number;
  currentIndex: number | null;
  allDone: boolean;
  onBack: () => void;
}) {
  return (
    <header className={own.header}>
      <div className={own.headerLeft}>
        <button
          type="button"
          className={own.back}
          aria-label="Zurück zu den Lektionen"
          onClick={onBack}
        >
          ‹
        </button>
        <div>
          <div className={own.brand}>
            Lektion {lesson.number} · {lesson.title}
          </div>
          <h1 className={own.title}>{title}</h1>
        </div>
      </div>
      <StageDots
        lesson={lesson}
        doneCount={doneCount}
        currentIndex={currentIndex}
        allDone={allDone}
      />
    </header>
  );
}
